import { render, staticRenderFns } from "./CardMovements.vue?vue&type=template&id=f531ae62&"
import script from "./CardMovements.vue?vue&type=script&lang=js&"
export * from "./CardMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports